<script lang="ts" setup>
import { provideLayout } from '@sigma/ui/layout/Layout.jsx';
import PageLayout from '@sigma/ui/layout/PageLayout.vue';
import LoaderOverlay from '@sigma/ui/LoaderOverlay.vue';

provideLayout(PageLayout);
</script>

<template>
  <div :class="css.main">
    <ClientOnly>
      <div :class="css.container">
        <slot />
      </div>

      <template #fallback>
        <LoaderOverlay />
      </template>
    </ClientOnly>
  </div>
</template>

<style lang="scss" module="css">
.main {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  max-width: $container-width;
  margin: auto;
}

.container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
</style>
